import React from 'react';
import {FloatButton} from "antd";
import {MenuOutlined} from "@ant-design/icons";

/**
 * п.5.1: плавающее меню действий. Дублирует действия из верхней части страницы,
 * чтобы не приходилось прокручивать список вверх. Всегда видно в правом нижнем углу.
 *
 * actions: [{ key, label, icon?, onClick, disabled? }]
 */
const FloatActionMenu = ({actions = [], icon}) => {
    const visibleActions = actions.filter(Boolean);
    if (!visibleActions.length) {
        return null;
    }
    return (
        <>
            <FloatButton.BackTop visibilityHeight={200} style={{right: 24, bottom: 24}}/>
            <FloatButton.Group
                trigger="click"
                type="primary"
                style={{right: 24, bottom: 84}}
                icon={icon || <MenuOutlined/>}
            >
                {visibleActions.map((a, i) => (
                    <FloatButton
                        key={a.key || i}
                        icon={a.icon}
                        tooltip={a.label}
                        onClick={a.disabled ? undefined : a.onClick}
                    />
                ))}
            </FloatButton.Group>
        </>
    );
};

export default FloatActionMenu;
